module.exports = __webpack_public_path__ + "img/bg5.a9787bcb.png";